export default (params) => ({
  trigger: {
    name: 'order_block.read_explanation_leasing',
    params: params,
  },
  config: {
    schema: {
      subject_type: {
        enum: [
          'item',
          'label',
        ],
      },
      subject_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        sub_feature: 'leasing_details',
      },
    },
  },
});
